import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

// Icon mapper
const iconMap = {
  PlayArrow: PlayArrowIcon,
  Autorenew: AutorenewIcon,
  PauseCircle: PauseCircleIcon,
  CheckCircle: CheckCircleIcon,
  ErrorOutline: ErrorOutlineIcon,
  default: HelpOutlineIcon,
};

// Centralized status formatter
export const getStatusInfo = (statuses, statusName) => {
  const normalized = (statusName || "Unknown").toLowerCase();

  const match = statuses.find(
    (s) => s?.statusname?.toLowerCase() === normalized
  );

  const Icon = iconMap[match?.icon] || iconMap["default"];

  return {
    color: match?.color || "grey",
    Icon,
    label: match?.statusname || statusName || "Unknown",
  };
};
